import { SERVICE_TYPE_CHOICES } from '@rover/constants/src/translations/service.constants';
import { ZIndex } from '@rover/kibble/styles';
import { WEEKDAY_PARAMS } from '@rover/react-lib/src/factories/dayFactory';

export const DOG_SIZE_FIELD = 'dogSize';

export const ADVANCED_FILTER_FIELDS = new Set([
  'acceptsOnlyOneClient',
  'apse',
  'bathingGrooming',
  'catCare',
  'dogsAllowedOnBed',
  'dogsAllowedOnFurniture',
  'hasFencedYard',
  'hasHouse',
  'hasNoChildren',
  'isPremier',
  'knowsFirstAid',
  'noCagedPets',
  'noCats',
  'noChildren05',
  'noChildren612',
  'nonSmoking',
  'personDoesNotHaveDogs',
  'petsitusa',
  'puppy',
]);

export const STAFF_ONLY_FIELDS = new Set([
  'searchScoreDebug',
  'injectedMedication',
  'searchCurrentProvider',
  'inUnlaunchedCountry',
  'specialNeeds',
  'oralMedication',
  'moreThanOneClient',
  'uncratedDogs',
  'unspayedFemales',
  'nonNeuteredMales',
  'femalesInHeat',
  'premierMatching',
  'premierOrRoverMatch',
  'isMemberOfSitterToSitter',
  'isMemberOfSitterToSitterPlus',
  'providerGroup',
  'agency',
]);

export const BOOLEAN_FIELDS = new Set([
  ...WEEKDAY_PARAMS,
  ...ADVANCED_FILTER_FIELDS,
  'searchScoreDebug',
  'injectedMedication',
  'searchCurrentProvider',
  'inUnlaunchedCountry',
  'specialNeeds',
  'oralMedication',
  'moreThanOneClient',
  'uncratedDogs',
  'unspayedFemales',
  'nonNeuteredMales',
  'femalesInHeat',
  'premierMatching',
  'premierOrRoverMatch',
  'isMemberOfSitterToSitter',
  'isMemberOfSitterToSitterPlus',
  'morningAvailability',
  'middayAvailability',
  'eveningAvailability',
  'fulltimeAvailability',
  'giantDogs',
  'largeDogs',
  'mediumDogs',
  'smallDogs',
  'starSitter',
  'bypassInterstitial',
]);

export const DATE_FIELDS = new Set(['startDate', 'endDate']);

export const HIDE_DATE_CONSTRAINED_SEARCH_PROMPT_COOKIE = 'date_constraint_suggestion_dismissed';

export const HIDE_DATE_CONSTRAINED_SEARCH_PROMPT_DAYS = 14;

export const NUMBER_FIELDS = new Set([
  'maxprice',
  'minprice',
  'spacesRequired',
  'dogCount',
  'catCount',
  'puppyCount',
  'page',
]);

export const ARRAY_STRING_FIELDS = new Set(['pet', 'petType', 'rawLocationTypes', 'businessType']);

export const ARRAY_NUMBER_FIELDS = new Set(['providerGroup', 'agency']);

export const ARRAY_FIELDS = new Set([...ARRAY_STRING_FIELDS, ...ARRAY_NUMBER_FIELDS]);

export const PROVIDE_AS_ARRAY_IN_QUERY_FIELDS = new Set(['rawLocationTypes']);

export const EMPTY_ALLOWABLE_FIELDS = new Set(['pet']);

export const SEARCH_QUERY_FALLBACK_FIELDS = new Set([
  'pet',
  'petType',
  'location',
  'centerlat',
  'centerlng',
  'locationType',
  'serviceType',
  'catCare', // needs to be here to allow cat-sitting SEO pages to set cat_care = True on the server
  'middayAvailability',
  'noCats',
  'catCare',
  'puppy',
  'noChildren05',
  'noChildren612',
  'smallDogs',
  'mediumDogs',
  'largeDogs',
  'giantDogs',
  'personDoesNotHaveDogs',
  'acceptsOnlyOneClient',
  'hasNoChildren',
  'unspayedFemales',
  'nonNeuteredMales',
  'femalesInHeat',
]);

export const SEARCH_QUERY_OVERRIDE_FIELDS = new Set(['startDate', 'endDate']);

export const PET_SIZES_FIELDS = new Set(['smallDogs', 'mediumDogs', 'largeDogs', 'giantDogs']);

export const SPACES_REQUIRED_SUPPORTED_SERVICES = new Set([
  SERVICE_TYPE_CHOICES.boarding,
  SERVICE_TYPE_CHOICES.dropIn,
  SERVICE_TYPE_CHOICES.walking,
]);

export const SHOW_SPACES_REQUIRED_WITH_PETS_SERVICES = new Set([
  SERVICE_TYPE_CHOICES.dropIn,
  SERVICE_TYPE_CHOICES.walking,
]);

export const CAT_DOG_PREFERENCES_SUPPORTED_SERVICES = new Set([
  SERVICE_TYPE_CHOICES.boarding,
  SERVICE_TYPE_CHOICES.dayCare,
]);

export const DROP_OFF_PICK_UP_SUPPORTED_SERVICES = new Set([SERVICE_TYPE_CHOICES.boarding]);

const GUTTER = 5;
const LEFT_WIDTH = 320;

export const LAYOUT = {
  GUTTER,
  LEFT_WIDTH,
  AVAILABLE_WIDTH: `(100% - ${LEFT_WIDTH + GUTTER * 3}px)`,
  WIDE_WIDTH_PERCENT: 0.58,
  NARROW_WIDTH_PERCENT: 0.42,
};

export const MAP_SIZES = {
  SMALL: 'small',
  LARGE: 'large',
};

export const ON_MAP_CHANGE_SEARCH = {
  SHOULD_SEARCH: 'true',
  SHOULD_NOT_SEARCH: 'false',
};

export const SEARCH_PAGE_Z_INDEX = {
  ADVANCED_FILTER_BUTTON_FIXED: ZIndex.NAVBAR_FIXED,
  ADVANCED_FILTER_MODAL: ZIndex.MODAL_OVERLAY,
  SEARCH_RESULT_CARD: {
    BADGE_CLOSED: 3,
    BADGE_OPEN: 4,
    INTERACTIVE: 2,
    PROFILE_ANCHOR: ZIndex.ONE.value,
    SCORE_DATA: ZIndex.NAVBAR.value + 1,
  },
  SEARCH_RESULTS_WRAPPER: 1,
  STICKY_SIDEBAR: 3,
};

export const PRICE_FILTER = {
  DEFAULT_MIN_PRICE: 1,
  DEFAULT_MAX_PRICE: 250,
};

export const MAX_ALLOWED_PETS = 100;

export const SEARCH_SOURCE = {
  SEARCH_MODAL: 'search-modal',
};
